import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, findDomFromVNode } from 'intact-vue';
import { isArray } from 'intact-shared';
import { bind } from '../utils';
import { makeStyles } from './styles';
import { theme } from '../../styles/theme';
import { useConfigContext } from '../config';
var typeDefs = {
  disabled: Boolean,
  color: String,
  inset: String
};
var defaults = function defaults() {
  return {
    color: theme.color.primary,
    inset: '-1px'
  };
};
export var Wave = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Wave, _Component);
  function Wave() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.instance = null;
    _this.className = void 0;
    _this.timer = null;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Wave.prototype;
  _proto.initClassName = function initClassName() {
    var _this$get = this.get(),
      color = _this$get.color,
      inset = _this$get.inset;
    this.className = makeStyles(color || theme.color.primary, inset, this.config.k);
  };
  _proto.mounted = function mounted() {
    var children = this.get('children');
    var node = findDomFromVNode(children, true);
    if (!node || node.nodeType !== 1) {
      return;
    }
    this.instance = node;
    node.addEventListener('click', this.onClick);
  };
  _proto.beforeUnmount = function beforeUnmount() {
    if (this.instance) {
      this.instance.removeEventListener('click', this.onClick);
    }
    this.resetAnimation();
  };
  _proto.onClick = function onClick(e) {
    var _this2 = this;
    this.initClassName();
    var instance = this.instance;
    var _this$get2 = this.get(),
      disabled = _this$get2.disabled;
    var node = e.target;
    // configProvider全局禁用动效
    if (this.config.disableWave) return;
    // 点击输入框中的icon时，此时输入框不需要动效
    var isInput = instance.classList.contains('k-input-wrapper');
    if (disabled || isInput && node.classList.contains(this.config.cls('icon'))) return;
    this.resetAnimation();
    instance.addEventListener('animationend', this.resetAnimation);
    this.timer = window.setTimeout(function () {
      instance.classList.add(_this2.className);
    });
  };
  _proto.resetAnimation = function resetAnimation() {
    var node = this.instance;
    if (!node) return;
    node.classList.remove(this.className);
    node.removeEventListener('animationend', this.resetAnimation);
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };
  return Wave;
}(Component);
Wave.typeDefs = typeDefs;
Wave.defaults = defaults;
Wave.template = function () {
  var children = this.get('children');
  if (process.env.NODE_ENV !== 'production') {
    if (!children || isArray(children) && children.length > 1) {
      throw new Error('Wave must receive only one Element children');
    }
  }
  return children;
};
__decorate([bind], Wave.prototype, "mounted", null);
__decorate([bind], Wave.prototype, "onClick", null);
__decorate([bind], Wave.prototype, "resetAnimation", null);